/** Q115 is an explicit review outcome when the RN cannot identify the physician. */
export const PHYSICIAN_NEEDS_VERIFICATION = "Physician needs verification";
export function physicianSearchInputError(name, address) {
    if (!hasFullPhysicianName(name)) {
        return "Enter the physician's first and last name. A first name, last name, or initials alone are not enough. If you cannot obtain the full name, ask the agency to verify the physician.";
    }
    if (!address.trim()) {
        return "Add the physician's office address, city, or ZIP code. Typed text is fine; you do not need to choose a suggestion. If you cannot obtain it, ask the agency to verify the physician.";
    }
    return null;
}
/** A minimum input check, not evidence that the physician's identity is verified. */
export function hasFullPhysicianName(name) {
    const parts = name
        .normalize("NFC")
        .trim()
        .split(/[\s,]+/)
        .filter(Boolean);
    while (parts.length && /^(dr|doctor)\.?$/i.test(parts[0])) {
        parts.shift();
    }
    // Strip suffix credentials, not name words throughout the input. Preserve the
    // surname "Do"; unpunctuated "DO" is treated as a credential only in capitals.
    while (parts.length &&
        (/^(m\.?d\.?|n\.?p\.?|p\.?a\.?-?c?|r\.?n\.?|aprn|fnp(?:-bc|-c)?|dnp|ph\.?d\.?)$/i.test(parts[parts.length - 1]) ||
            /^(DO|D\.O\.?)$/.test(parts[parts.length - 1]))) {
        parts.pop();
    }
    const nameParts = parts.filter((part) => /^[\p{L}\p{M}]+(?:['’\-‐‑][\p{L}\p{M}]+)*$/u.test(part) && !/^[a-z]$/i.test(part));
    return nameParts.length >= 2;
}
export function isPhysicianPending(value) {
    try {
        const parsed = typeof value === "string" ? JSON.parse(value) : value;
        return Boolean(parsed &&
            typeof parsed === "object" &&
            parsed.verificationStatus === "needs_verification");
    }
    catch {
        return false;
    }
}
//# sourceMappingURL=physician-verification.js.map